import React from 'react';
import { Grid } from '@material-ui/core';
import { Formik } from 'formik';
import * as yup from 'yup';
import FormikTextField from 'catalyst/core/form/TextField/variants/FormikTextField';
import FormikSelect from 'catalyst/core/form/Select/variants/FormikSelect';
import Button from 'catalyst/core/Button';
import { useHistory } from 'react-router-dom';
import AdditionalFields from 'components/settings/Users/Edit/AdditionalFields';

const validationSchema = {
    name: yup
        .string('Enter your Name')
        .min(2, 'Name should be of minimum 2 characters length')
        .required('Name is required'),
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
};

const UserEditForm = ({ initialValues, updateUser }) => {
    const history = useHistory();
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                updateUser(values);
            }}
            validationSchema={yup.object(validationSchema)}
        >
            {({ submitForm, isSubmitting, errors, touched, values }) => {
                const submit = (event) => {
                    event.preventDefault();
                    submitForm();
                };
                return (
                    <>
                        <Grid container direction="row" spacing={1}>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{ marginBottom: '10px' }}
                            >
                                <FormikTextField
                                    id="name"
                                    label="Name"
                                    name="name"
                                    type="text"
                                    variant="outlined"
                                    placeholder={'e.g. John Doe'}
                                    fullWidth
                                    error={errors.name}
                                    touched={touched.name}
                                    helperText={
                                        (touched.name && errors.name) ||
                                        'New user full name'
                                    }
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{ marginBottom: '10px' }}
                            >
                                <FormikTextField
                                    id="email"
                                    label="Email"
                                    name="email"
                                    type="email"
                                    variant="outlined"
                                    placeholder={'e.g. john.doe@domain.com'}
                                    fullWidth
                                    error={errors.email}
                                    touched={touched.email}
                                    helperText={
                                        (touched.email && errors.email) ||
                                        'New user email address. (required to authenticate users)'
                                    }
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{ marginBottom: '10px' }}
                            >
                                <FormikTextField
                                    id="phone"
                                    label="Phone"
                                    name="phone"
                                    type="text"
                                    variant="outlined"
                                    placeholder={'e.g. +44771234567890'}
                                    fullWidth
                                    error={errors.phone}
                                    touched={touched.phone}
                                    helperText={touched.phone && errors.phone}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{ marginBottom: '10px' }}
                            >
                                <FormikTextField
                                    id="qsId"
                                    label="Qlik Sense User Id"
                                    name="qsId"
                                    type="text"
                                    variant="outlined"
                                    placeholder={'e.g. John.Doe'}
                                    fullWidth
                                    error={errors.qsId}
                                    touched={touched.qsId}
                                    helperText={
                                        (touched.qsId && errors.qsId) ||
                                        "User's Qlik Sense User ID"
                                    }
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{ marginBottom: '10px' }}
                            >
                                <FormikTextField
                                    id="directory"
                                    label="Qlik Sense User Directory"
                                    name="directory"
                                    type="text"
                                    variant="outlined"
                                    placeholder={'e.g. COEUS'}
                                    fullWidth
                                    error={errors.directory}
                                    touched={touched.directory}
                                    helperText={
                                        (touched.directory &&
                                            errors.directory) ||
                                        "User's Qlik Sense Directory"
                                    }
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{ marginBottom: '10px' }}
                            >
                                <FormikSelect
                                    id="role"
                                    label="User Role"
                                    name="role"
                                    items={[
                                        {
                                            value: 'Admin',
                                            label: 'Admin',
                                        },
                                        {
                                            value: 'User',
                                            label: 'User',
                                        },
                                    ]}
                                    fullWidth
                                    error={errors.directory}
                                    touched={touched.directory}
                                    helperText={
                                        (touched.directory &&
                                            errors.directory) ||
                                        "User's COEUS role"
                                    }
                                />
                            </Grid>
                            <AdditionalFields
                                errors={errors}
                                touched={touched}
                                values={values}
                            />
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            spacing={1}
                            justifyContent={'space-between'}
                            style={{ marginBottom: '10px' }}
                        >
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={submit}
                                >
                                    Update Account
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => history.goBack()}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                );
            }}
        </Formik>
    );
};

export default UserEditForm;
